import Link from 'next/link';

import Button from '@gds/Button/Button';
import { useSearchWidgetTracking } from '@search/Hooks/UseSearchWidgetTracking';

import type { searchWidgetMessages } from '../../../SearchWidget/SearchWidget.messages';

import styles from './BuyOnlineCta.module.css';

interface CtaProps {
  strings: Record<keyof typeof searchWidgetMessages, string>;
  buyOnlineCtaUrl: string;
}

const BuyOnlineCta = ({ strings, buyOnlineCtaUrl }: CtaProps) => {
  const { trackLinkCta } = useSearchWidgetTracking(buyOnlineCtaUrl, strings.buyOnlineCta);

  return (
    <div className={styles.buyOnlineCta}>
      <div className={styles.or}>
        <span className={styles.copy}>{strings.or}</span>
      </div>
      <Button
        Component={Link}
        aria-label="buyonline-button"
        className={styles.button}
        fullWidth
        href={buyOnlineCtaUrl}
        type="submit"
        variant="outlined"
        onClick={trackLinkCta}
      >
        {strings.buyOnlineCta}
      </Button>
    </div>
  );
};

export default BuyOnlineCta;
